import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const QuickActionButton = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);

  const getContextAction = () => {
    const path = location?.pathname;
    
    if (path === '/dashboard' || path === '/projects-list') {
      return {
        icon: 'Plus',
        label: 'New Project',
        action: () => navigate('/project-wizard'),
        color: 'bg-primary hover:bg-primary/90'
      };
    }
    
    if (path === '/boq-editor') {
      return {
        icon: 'FilePlus',
        label: 'Add BOQ Line',
        action: () => {},
        color: 'bg-accent hover:bg-accent/90'
      };
    }
    
    if (path === '/rfq-management') {
      return {
        icon: 'FileText',
        label: 'Generate RFQ',
        action: () => {},
        color: 'bg-success hover:bg-success/90'
      };
    }
    
    if (path === '/vendor-quotes') {
      return {
        icon: 'Upload',
        label: 'Upload Quote',
        action: () => {},
        color: 'bg-warning hover:bg-warning/90'
      };
    }
    
    if (path === '/comparison-and-award') {
      return {
        icon: 'Award',
        label: 'Award Contract',
        action: () => {},
        color: 'bg-success hover:bg-success/90'
      };
    }

    return {
      icon: 'Plus',
      label: 'Quick Action',
      action: () => {},
      color: 'bg-primary hover:bg-primary/90'
    };
  };

  const contextAction = getContextAction();

  const handleClick = () => {
    contextAction?.action();
  };

  const handleMouseEnter = () => {
    setIsExpanded(true);
  };

  const handleMouseLeave = () => {
    setIsExpanded(false);
  };

  return (
    <button
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 h-14 rounded-full shadow-xl transition-all duration-smooth ${contextAction?.color} text-white focus-ring ${
        isExpanded ? 'px-6' : 'w-14 justify-center'
      }`}
      aria-label={contextAction?.label}
    >
      <Icon name={contextAction?.icon} size={24} />
      {isExpanded && (
        <span className="text-sm font-medium whitespace-nowrap">
          {contextAction?.label}
        </span>
      )}
    </button>
  );
};

export default QuickActionButton;